import http from './http';

export interface WillData {
  id?: string;
  hasWill?: boolean;
  physicalLocation?: string;
  dateSigned?: string;
  executorName?: string;
  executorContact?: string;
  executorNotified?: string;
  alternateExecutorName?: string;
  alternateExecutorContact?: string;
  attorneyName?: string;
  attorneyContact?: string;
  specificInstructions?: string;
  documentPath?: string;
  isLocked?: boolean;
}

class WillService {
  async createWill(data: Omit<WillData, 'id'>): Promise<WillData> {
    const response = await http.post('/api/will', data);
    return response.data.data || response.data;
  }

  async updateWill(id: string, data: Partial<WillData>): Promise<WillData> {
    const response = await http.patch(`/api/will/${id}`, data);
    return response.data.data || response.data;
  }

  async getWillById(id: string, targetUserId?: string): Promise<WillData> {
    const url = targetUserId
      ? `/api/will/${id}?targetUserId=${targetUserId}`
      : `/api/will/${id}`;
    const response = await http.get(url);
    return response.data.data || response.data;
  }

  async getAllWills(targetUserId?: string): Promise<WillData[]> {
    const url = targetUserId
      ? `/api/will?targetUserId=${targetUserId}`
      : '/api/will';
    const response = await http.get(url);
    return response.data.data || response.data;
  }

  async deleteWill(id: string): Promise<void> {
    await http.delete(`/api/will/${id}`);
  }

  async lockWill(id: string): Promise<void> {
    await http.post(`/api/will/${id}/lock`);
  }

  async unlockWill(id: string, emails: string[]): Promise<void> {
    await http.post(`/api/will/${id}/unlock`, { emails });
  }

  async getWillAccessGrants(id: string): Promise<any[]> {
    const response = await http.get(`/api/will/${id}/access-grants`);
    return response.data.data || response.data;
  }
}

export const willService = new WillService();
